import { valueToPercent } from '@chakra-ui/utils';
import { CSSProperties } from 'react';

export type Orientation = 'horizontal' | 'vertical';

export const orient = (options: {
  orientation: Orientation;
  vertical: CSSProperties;
  horizontal: CSSProperties;
}): CSSProperties => {
  const { orientation, vertical, horizontal } = options;

  return orientation === 'vertical' ? vertical : horizontal;
};

export const getTrackPercent = (
  value: number,
  min: number,
  max: number,
  isReversed: boolean
): number => {
  const reversedValue = max - value + min;
  const trackValue = isReversed ? reversedValue : value;
  const trackPercent = valueToPercent(trackValue, min, max);

  return trackPercent;
};
